var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 4,
    viewBox: "0 0 6 4",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.598155 1.40013L2.59816 3.40013C2.79816 3.60013 3.13149 3.60013 3.39816 3.40013L5.39816 1.40013C5.73149 1.0668 5.53149 0.466797 4.99816 0.466797H0.998155C0.531489 0.466797 0.264822 1.0668 0.598155 1.40013Z",
    fill: "#4d4d4d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownArrow);
export default __webpack_public_path__ + "static/media/dropdownArrow.a467621dbd318f7586c7282924a1006f.svg";
export { ForwardRef as ReactComponent };